import React from 'react';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';

const ProjectLocationLoader = () => {
  return (
    <div style={{ padding: 20 }}>
      <LoadingPlaceholder
        type="textRow"
        ready={false}
        showLoadingAnimation
        color="#E0E0E0"
        style={{ height: '1.3rem', marginTop: '0.6em', marginBottom: '10px', width: '60%' }}
      >
        <span style={{ width: '100%' }} />
      </LoadingPlaceholder>
      <div style={{ display: 'flex' }}>
        {Array(2)
          .fill('')
          .map((item, index) => (
            <LoadingPlaceholder
              key={`lp-${index}`}
              type="rect"
              ready={false}
              showLoadingAnimation
              color="#E0E0E0"
              style={{
                height: '40px',
                width: '20%',
              }}
            >
              <span style={{ width: '100%' }} />
            </LoadingPlaceholder>
          ))}
      </div>
      <div style={{ display: 'flex', marginTop: 10 }}>
        {Array(3)
          .fill('')
          .map((item, index) => (
            <LoadingPlaceholder
              key={`lp-${index}`}
              type="rect"
              ready={false}
              showLoadingAnimation
              color="#E0E0E0"
              style={{
                height: '100px',
                width: '25%',
              }}
            >
              <span style={{ width: '100%' }} />
            </LoadingPlaceholder>
          ))}
      </div>
    </div>
  );
};

export default ProjectLocationLoader;
